import { styles, variants, NavigationListItemTheme } from '../NavigationListItemStyles.css';
import { baseTheme } from './NavigationListItemBaseTheme.css';
import { multiVariantStyles } from './NavigationListItemVariants.css';

const NavigationListItemStableTheme: NavigationListItemTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

export { NavigationListItemStableTheme };
